import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    tabs: {
        display: 'flex',
        borderBottom: '2px solid #ccc',
        justifyContent: 'center',
        paddingBottom: '26px',
    },
    tab: {
        padding: '10px 20px',
        cursor: 'pointer',
        fontSize: '21px',
        fontFamily: 'OpenSans',
        transition: 'background-color 0.3s'
    },
    active: {
        borderBottom: '4px solid #3FD1DF',
    },
    selectFromControl: {
        minWidth: '200px',
        paddingRight: '10px',
        fontSize: `${theme.palette.textSizeMedium} !important`,
        '& .MuiSelect-select': {
            paddingTop: '22px !important',
            paddingBottom: '7px !important'
        }
    },

    inputLabel: {
        backgroundColor: 'white',
        border: '2px solid black',
        borderRadius: 0,
    },

    tabViewContainer: {
        padding: '40px 30px 30px 30px',
        margin: '0px 40px',
        border: '2px solid black',
        marginTop: '20px',
    },

    tabHeadingContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },

    heading: {
        margin: '0px !important',
        fontSize: '22px',
        fontWeight: "bold",
        fontFamily: 'OpenSans !important',
    },

    table: {
        '& .MuiDataGrid-columnHeaderTitle': {
            fontSize: '15px !important',
            fontFamily: 'Noto Sans',
        },

        '& .MuiDataGrid-columnHeader': {
             backgroundColor: '#F2F3F5'
        },
    },

    engagementPercentage: {
        display: 'flex',
        alignItems: 'center',
        columnGap: '10px',
    },

    row: {
        letterSpacing: '0px',
        color: '#4E4E4E',
        textAlign: 'center',
        fontSize: '15px',
        fontFamily: 'Noto Sans',
    },

    customPagination: {
        '& .MuiPagination-root': {
            paddingRight: '25px',
            paddingBottom: '8px'
        },
        '& .MuiPagination-root .MuiPagination-ul': {
            flexWrap: 'nowrap'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child svg, & .MuiPagination-root .MuiPagination-ul li:last-child svg':
        {
            display: 'none'
        },
        '& .MuiPagination-root .MuiPagination-ul li:last-child': {
            flexBasis: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center'
        },
        '& .MuiPagination-root .MuiPagination-ul li:first-child > button, & .MuiPagination-root .MuiPagination-ul li:last-child > button::before':
        {
            margin: '0px 5px'
        }
    },
    showPaginationDesc: {
        float: 'left',
        position: 'absolute',
        left: '22px'
    },

    root: {
        display: 'flex',
        maxWidth: '100vw',
        overflowX: 'hidden',
        background: 'white'
    },

    pageItem: {
        border: '1px solid #E9EBF0 !important',
        margin: '0px !important',
        borderRadius: '0px !important',
        height: '32px !important',
        '& button::after': {
            margin: '0px'
        }
    },

    filterIcon: {
        width: 20,
        height: 20,
        cursor: 'pointer'
    },

    hiddenDisplay: {
        display: 'none !important',
    },
    accountWithFeature: {
        cursor: 'pointer',
        background: 'transparent',
        border: 'none',
        textDecoration: 'underline',
    },

    enabled: {
        background: 'transparent',
        border: 'none',
    },

    formGroup: {
        display: 'flex',
        gap: '16px',
        marginBottom: '20px'
    },

    dataTable: { height: '450px' },

    featureEngagement: { marginTop: '20px' },
    
    activatedFeaturesAccount: {
        flexWrap: 'nowrap !important',
        alignItems: 'center',
        display: 'flex',
        columnGap: 15,
        fontSize: '15px',
        fontWeight: '600',
        fontFamily: 'Noto Sans',
    },
    
    clientsList: { height: '420px', width: '600px' },

    timeFeatureEngagementContainer: {
        marginTop: '40px',
        display: 'flex',
        justifyContent: 'flex-start',
        columnGap: '8px',
        alignItems: 'center',
        rowGap: '10px',
    },

    timeFormGroup: {
        marginTop: '20px',
    },

    emptyDataText: {
        fontSize: '18px',
        color: '#ccc',
        fontWeight: '500'
    },

    noDocumentIcon: { width: 140, height: 140, marginTop: '8px' },
    churnedUserCount:{ 
        fontWeight: 'bold',
        fontSize: '1.5rem',
        color: 'black',
        lineHeight:1.5 ,
        alignSelf:'center'
    },
    infoIcon:{
        color: "#676868",
        alignSelf:"flex-start",
        margin:'3px'
    },
    churnedUserRow:{ display: 'flex', flexDirection:'row'},
    churnedUserTitle:{ flex: 1, fontSize:"large", textAlign:"center" },
    churnedUserContaier: {       
       paddingTop: '5px',
        display: 'flex',
        flexDirection: 'column',
        cursor: 'pointer',
        // border:'2px solid #dedede'
        border:'2px solid black'
    },
    activeCategory: {
        border: '2px solid #3FD1DF',
    },
    bottomMargin:{
        marginBottom:'32px'
    },
    containerMargin:{
        marginBottom:'20px'
    }
}));